export default __webpack_public_path__ + "static/media/paid.c45afa9d.png";